let angular = require('angular');

require('angular-router-browserify')(angular);
require('angular-sanitize');

angular.module('app', ['ngRoute', 'ngSanitize']);